import { IDayPartBoundary } from 'state/menu/main-menu/types';
import { IMenuObjectWithDaypart } from 'utils/availability';
import {
  getMenuItemDayParts,
  isAvailableForActiveDayParts,
} from 'utils/availability/daypart-availability';

export function isLegacyMenuObjectOutOfActiveDayParts({
  activeDayParts,
  entry,
  isDayPartsSourceResolved,
}: {
  activeDayParts: IDayPartBoundary[];
  entry: IMenuObjectWithDaypart | null | undefined;
  isDayPartsSourceResolved: boolean;
}): boolean {
  return Boolean(
    isDayPartsSourceResolved &&
      entry &&
      getMenuItemDayParts(entry).length > 0 &&
      !isAvailableForActiveDayParts({ activeDayParts, menuData: entry })
  );
}
